import { defineComponent as _defineComponent } from 'vue'

  const __default__ = {
    model: {
      prop: 'modelValue',
      event: 'update:modelValue',
    },
  };

import _ from 'underscore';
    import { ref, computed, onMounted, onBeforeUnmount, nextTick, defineComponent, h, withDefaults } from 'vue';

    type ObjectOptionItem = { key: string; text: string };
    type OptionItem = ObjectOptionItem | string | number;
    type Options = OptionItem[];

    
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'SelectInput',
  props: {
    disabled: { type: Boolean },
    defaultLabel: null,
    options: null,
    toTarget: null,
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
        (e: 'update:modelValue', value: string | number): void;
    }), expose: any, slots: any, attrs: any }) {

const props = __props as {
        disabled?: boolean;
        defaultLabel?: string;
        options: Options;
        toTarget?: string,
        modelValue?: string | number | null;
    }

    

    

    const selectInput = ref<HTMLElement | null>(null);
    const shouldShowContent = ref(false);
    const contentStyle = ref({});

    const updatePosition = () => {
        const trigger = selectInput.value;
        if (!trigger) return {};

        const rect = trigger.getBoundingClientRect();
        contentStyle.value = {
            position: 'absolute',
            top: `${rect.bottom + window.scrollY}px`,
            left: `${rect.left + window.scrollX}px`,
            width: `${rect.width}px`,
            zIndex: 10001,
        };
    }

    const controllText = computed<string | number>(() => {
        const item = _.find(props.options, (el) =>
            typeof el === 'object'
            ? el.key === props.modelValue
            : el === props.modelValue,
        );

        if (!item) {
            if (props.modelValue === undefined || props.modelValue === null) {
                return props.defaultLabel || '';
            }

            return props.modelValue;
        }

        return typeof item === 'object' ? item.text : props.modelValue;
    });

    const shouldShowFallBack = computed(() => {
        return (props.modelValue === undefined || props.modelValue === null) && !!props.defaultLabel;
    });

    const windowClickHandler = (e: Event) => {
        if (!e.target || selectInput.value?.contains(e.target as Node)) {
            return;
        }

        shouldShowContent.value = false;
    };
    

    const showContent = async () => {
        if (props.disabled) {
            return;
        }
        if (shouldShowContent.value && props.toTarget) {
            document.removeEventListener('scroll', updatePosition, true)
        } else if(props.toTarget) {
            await nextTick(updatePosition);
            document.addEventListener('scroll', updatePosition, true);
        }

        shouldShowContent.value = !shouldShowContent.value;
    };

    const selectItem = (item: OptionItem) => {
        shouldShowContent.value = false;
        const value = typeof item === 'object' ? item.key : item;
        emit('update:modelValue', value);
    };
    

    const getObserver = () => {
        return new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    shouldShowContent.value = false;
                }
            });
        });
    }

    const observer = getObserver();

    onMounted(() => {
        if(selectInput.value) {
            observer.observe(selectInput.value)
        }
        document.addEventListener('click', windowClickHandler);
    });

    onBeforeUnmount(() => {
        observer.disconnect()
        document.removeEventListener('click', windowClickHandler);
    });


return { __sfc: true,props, emit, selectInput, shouldShowContent, contentStyle, updatePosition, controllText, shouldShowFallBack, windowClickHandler, showContent, selectItem, getObserver, observer }
}

})